import React, { useEffect } from 'react'
import { Route, Redirect } from 'react-router-dom'
import Cryptr from 'cryptr'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import queryString from 'query-string'

import { decrypt, getUser } from '../modules/Users/redux/userActions'
import { loginUser } from '../modules/Login/redux/authActions'
import { useHistory } from 'react-router-dom'

function PrivateRoute({ component: Component, auth, loginUser, getUser, decrypt, ...rest }) {
  let currentLocation = rest.location.pathname + rest.location.search
  const history = useHistory()

  useEffect(() => {
    const urlFromCRM = queryString.parse(rest.location.search)
    if (urlFromCRM.fromCRM) {
      const cryptr = new Cryptr('crm-password')
      const stringToDecrypt = urlFromCRM.fromCRM
      const decriptedMessage = cryptr.decrypt(stringToDecrypt)
      const parsedDecription = JSON.parse(decriptedMessage)
      loginUserFromCRM(parsedDecription)
    }
    if (urlFromCRM.fromTruckSales) {
      loginUserFromTruckSales(urlFromCRM.fromTruckSales)
    }
  }, [])

  const loginUserFromCRM = async (data) => {
    const user = await getUser(data.plaintiff)
    if (user) {
      await loginUser({
        email: user.email,
        password: user.password,
        isEncrypted: true,
      })
    }
  }

  const loginUserFromTruckSales = async (encryptedData) => {
    const decryptedData = await decrypt(JSON.parse(encryptedData))

    const user = await getUser(decryptedData.userId)
    if (user) {
      await loginUser({
        email: user.email,
        password: user.password,
        isEncrypted: true,
      })
    }

    history.push(`${decryptedData.pathname}/${decryptedData.contactId}`)
  }

  if (auth.isAuthenticated === false) {
    return (
      <Redirect
        to={{
          pathname: '/login',
          state: {
            fromPathname: currentLocation,
          },
        }}
      />
    )
  } else {
    return (
      <Route
        {...rest}
        render={(props) => {
          return auth.isAuthenticated === true ? <Component {...props} /> : <Redirect to='/' />
        }}
      />
    )
  }
}

PrivateRoute.propTypes = {
  auth: PropTypes.object.isRequired,
}

const mapStateToProps = (state) => ({
  auth: state.auth,
})
export default connect(mapStateToProps, { loginUser, getUser, decrypt })(PrivateRoute)
